import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

interface CartItemsResponse {
  items: any[];
}

@Injectable({
  providedIn: 'root'
})
export class CartService {

  private readonly editAddressFlagSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  editAddressdata$ = this.editAddressFlagSubject.asObservable();
  orderConfirmationData: any;

  private cartItemCountSubject = new BehaviorSubject<number>(0);
  cartItemCount$ = this.cartItemCountSubject.asObservable();


  constructor(private readonly http: HttpClient) {
  }

  getCartItem(userId: string) {
    const apiUrl: string = `${environment.apiBaseUrl}/cart/${userId}`;
    return this.http.get<CartItemsResponse>(apiUrl);
  }

  deleteCartItem(userId: string, itemId: string) {
    const apiUrl: string = `${environment.apiBaseUrl}/cart/remove/${userId}/${itemId}`;
    return this.http.delete(apiUrl);
  }

  addCartItem(data: any, userId: string) {
    const apiUrl: string = `${environment.apiBaseUrl}/cart/add/${userId}`;
    return this.http.post(apiUrl, data);
  }


  getCartItemCount(): Observable<number> {
    return this.cartItemCountSubject.asObservable();
  }


  updateCartItemCount(count: number) {
    this.cartItemCountSubject.next(count);
  }

  incrementCartCount() {
    const currentCount = this.cartItemCountSubject.value;
    this.cartItemCountSubject.next(currentCount + 1);
  }


  decrementCartCount(): void {
    const current = this.cartItemCountSubject.value;
    this.cartItemCountSubject.next(Math.max(current - 1, 0));
  }


  updateEditAddressFlag(value: boolean): void {
    this.editAddressFlagSubject.next(value);
  }

  getEditAddressFlag(): Observable<boolean> {
    return this.editAddressFlagSubject.asObservable();
  }

  addOrder(userId: string, cartId: string, data: any) {
    const apiUrl: string = `${environment.apiBaseUrl}/checkout/${cartId}/${userId}`;
    return this.http.post(apiUrl, data);
  }

  priceChanged(userId: string, cartId: string, data: any) {
    const apiUrl: string = `${environment.apiBaseUrl}/checkout/pay/${cartId}/${userId}`;
    return this.http.post(apiUrl, data);
  }

  addOrderWithNoPayment(userId: string, cartId: string, data: any) {
    const apiUrl: string = `${environment.apiBaseUrl}/checkout/nopay/${cartId}/${userId}`;
    return this.http.post(apiUrl, data);
  }

  setOrderConfirmationData(data: any) {
    this.orderConfirmationData = data;
  }

  getOrderConfirmationData() {
    return this.orderConfirmationData;
  }

  getFutureUserList(search: any = ""): Observable<any> {
    let url = `${environment.apiBaseUrl}/sharesuitesso/getAllUsers?page=0&size=100&keyword=${search}`;
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    });
    return this.http.get(url, { headers });
  }

  getClearanceUsersList(search: any = ""): Observable<any> {
    let url = `${environment.apiBaseUrl}/clearance-users/getAllWithoutPagination`;
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    });
    return this.http.get(url, { headers });
  }

  getOrders(orderID: any): Observable<any> {
    let url = `${environment.apiBaseUrl}/orders/${orderID}`;
    const headers = new HttpHeaders({
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
    });
    return this.http.get(url, { headers });
  }

  // roleWiseUserList(roleIds: any): Observable<any> {
  //   let url = `${environment.apiBaseUrl}/users/roles?roleIds=${roleIds}`;
  //   const headers = new HttpHeaders({
  //     'Access-Control-Allow-Origin': '*',
  //     'Content-Type': 'application/json',
  //     'External-API': 'API'
  //   });
  //   return this.http.get(url, { headers });
  // }

}
